import { createContext, useContext } from "react";

export const DeviceContext = createContext();

export function useDeviceContext() {
  return useContext(DeviceContext);
}
